import { OPENTRACK_TRACKING_STATUS } from 'constants/Opentrack';

export const getOpentrackTrackingInfo = (opentrackStatus, containerUpdates) => {
  switch (opentrackStatus) {
    case OPENTRACK_TRACKING_STATUS.TRACKING_COMPLETED:
    case OPENTRACK_TRACKING_STATUS.TRACKING:
      return {
        localizationSlug: opentrackStatus.toUpperCase(),
        badgeColor: 'green',
      };
    case OPENTRACK_TRACKING_STATUS.TRACKING_FAILED:
    case OPENTRACK_TRACKING_STATUS.TRACKING_STOPPED:
      return {
        localizationSlug:
          OPENTRACK_TRACKING_STATUS.TRACKING_FAILED.toUpperCase(),
        badgeColor: 'red',
      };
    default:
      if (containerUpdates) return getContainerUpdatesStatus(containerUpdates);
      return {
        localizationSlug: OPENTRACK_TRACKING_STATUS.NOT_TRACKING.toUpperCase(),
        badgeColor: 'gray',
      };
  }
};

const getContainerUpdatesStatus = (update) => {
  if (update?.is_tracking_stopped) {
    return {
      localizationSlug: OPENTRACK_TRACKING_STATUS.TRACKING_FAILED.toUpperCase(),
      badgeColor: 'red',
    };
  }

  if (update?.opentrack_status?.includes('updated')) {
    return {
      localizationSlug: OPENTRACK_TRACKING_STATUS.TRACKING.toUpperCase(),
      badgeColor: 'green',
    };
  }
  return {
    localizationSlug: OPENTRACK_TRACKING_STATUS.NOT_TRACKING.toUpperCase(),
    badgeColor: 'gray',
  };
};
